import React, { useState, useEffect } from 'react';
import styles from '../allEnquiresTab/specificationsTab.module.css';
import { IconButton } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { Deletes, Editicon, Edits, PasswordLock, View } from '../../../../Svg';
import CatPagination from '../../../../Website/utils/Pagination';
import DeleteModal from '../../../deleteModal/DeleteModal';
import PasswordModal from '../../../passwordModal/PasswordModal';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteUserAccountThunk } from '../../../../Website/redux/AccountUserSlice';

const AcoountUserComp = ({ userData, page, setPage, itemsPerPage, start, end, totalItems, handleOpenMenu }) => {

    const navigate = useNavigate()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPassopen, setIsopen] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const dispatch = useDispatch()
    const [order, setOrder] = useState(true)

    const handlepasswordClick = (id) => {
        setSelectedId(id)
        setIsopen(true)
    }

    const deleteUser = () => {
        dispatch(deleteUserAccountThunk(selectedId))
        setIsModalOpen(false);

    }

    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };

    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Account Users</h2>
                <button className={styles.addBtn} onClick={() => navigate('/addNewUser')}>Add New user</button>

            </div>
            {userData?.length > 0 ?
                <div className={styles.profilebodyContent}>
                    <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                        <table className={styles.spectable}>
                            <thead>
                                <tr>
                                    <th>Sl No
                                        <IconButton sx={{ padding: "2px !important" }} onClick={() => setOrder(!order)}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </th>
                                    <th>User name
                                        <IconButton sx={{ padding: "2px !important" }} onClick={() => handleOpenMenu('fullName')}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </th>
                                    <th>Email Id
                                        <IconButton sx={{ padding: "2px !important" }} onClick={() => handleOpenMenu('email')}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </th>
                                    <th>Phone number
                                        <IconButton sx={{ padding: "2px !important" }} onClick={() => handleOpenMenu('phone')}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </th>
                                    <th>Status
                                        <IconButton sx={{ padding: "2px !important" }} onClick={() => handleOpenMenu('activeStatus')}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </th>
                                    <th>Options</th>
                                </tr>
                            </thead>
                            <tbody className={styles.spectbody}>
                                {userData?.map((record, index) => (
                                    <tr key={record._id}>
                                        <td>{order ? index + 1 : userData?.length - index} </td>
                                        <td> {record?.fullName}</td>
                                        <td>{record.email}</td>
                                        <td>{record.phone}</td>
                                        <td>{record.activeStatus}</td>
                                        <td style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                            <div onClick={() => navigate(`/ViewAccountUser/${record?._id}`)} style={{ cursor: 'pointer' }}>
                                                <View />
                                            </div>
                                            <div onClick={() => navigate(`/editAccountUser/${record?._id}`)} style={{ cursor: 'pointer' }}>
                                                <Editicon />
                                            </div>
                                            <div onClick={() => handlepasswordClick(record?._id)} style={{ cursor: 'pointer' }}>
                                                <PasswordLock />
                                            </div>

                                            <div onClick={() => handleDeleteClick(record?._id)} style={{ cursor: 'pointer' }}>

                                                <Deletes />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <PasswordModal
                            isOpen={isPassopen}
                            onClose={() => setIsopen(false)}
                            selectedId={selectedId}
                        />

                        <DeleteModal
                            isOpen={isModalOpen}
                            heading={'Admin'}
                            onClose={() => setIsModalOpen(false)}
                            onDelete={deleteUser}
                        />


                        <CatPagination
                            start={start}
                            end={end}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            setPage={setPage}
                            page={page}
                        />
                    </div>
                </div>
                :
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
                    No data found
                </div>
            }
        </div>
    )
}

export default AcoountUserComp